import { Message } from "primereact/message";
import { useEffect, useMemo, useState } from "react";
import { ITopology, useGetTopologiesQuery } from "../../app/apiSlice";
import { useAppSelector } from "../../hooks/hooks";
import { useDispatch } from "react-redux";
import {
  initParamTopologyPagination,
  setParamTopologyPagination,
} from "./TreatmentSlice";
import HandleTreatment from "./HandleTreatment";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { DisplayDate } from "../../components/DisplayDate";
import { CorrespondenceEnv } from "../../utils/correspondenceEnv";
import { DisplayEnv } from "../../components/environnement/DisplayEnv";
import { useNavigate } from "react-router-dom";
import ActionsTopology from "./ActionsTopology";
import { IconMode } from "../../components/Mode/icon";
import { paginationForBack } from "./paginationForBack";

const RenderTopologies = () => {
  const paramPagination = useAppSelector(
    (state) => state.treatment.paramTopologiesPagination
  );
  const [first, setFirst] = useState<number>(0);

  const setPaginationForBack = useMemo(() => paginationForBack(paramPagination),[paramPagination])

  const { data, ...status } = useGetTopologiesQuery(setPaginationForBack);
  const dispatch = useDispatch();

  const runtimes = useAppSelector((state) => state.app.config.runtimeMode)

  const history = useNavigate();

  useEffect(() => {
    return () => {
      if(!paramPagination)dispatch(initParamTopologyPagination());
    };
  }, []);


  // set firts parameter to tell the current page of pagination component  
  useEffect(() => {
    setFirst(paramPagination.page*paramPagination.perPage)
  },[paramPagination])

  //pagintion stored in redux
  const paginate = (event: any) => {
    dispatch(
      setParamTopologyPagination({
        ...paramPagination,
        page: event.page,
        perPage: event.rows,
      })
    );
  };
  const onSort = (event: any) => {
    dispatch(
      setParamTopologyPagination({
        ...paramPagination,
        sort: event["sortOrder"],
        field: event["sortField"],
      })
    );
  };

  const CretationDateBodyTemplate = (data: ITopology) => {
    return <DisplayDate date={data.creationDate} />;
  };

  const ModificationDateBodyTemplate = (data: ITopology) => {
    return <DisplayDate date={data.modificationDate} />;
  };

  const EnvTemplate = (data: ITopology) => {
    return (
      <DisplayEnv
        name={CorrespondenceEnv(data.environnement)}
        code={data.environnement}
      />
    );
  };

  const EmptyMessage = () => {
    return <div>Aucun traitement n'a été trouvé</div>;
  };

  const NameTemplate = (data: ITopology) => {

    const runtime = useMemo(( ) => 
      runtimes.find((runtime) => runtime.name === data.runtimeMode)
    ,[data.runtimeMode])


    return (
      <>
        <div
          className="flex align-content-center link"
          onClick={(event) => {
            if (event.ctrlKey) {
              window.open(`/treatments/editor?t=${data.id}&v=${data.version}`, '_blank');
              return;
            }
            history(`editor?t=${data.id}&v=${data.version}`);
          }}
        >
            {runtime && <div className="flex align-items-center justify-content-center mr-2"><IconMode name={runtime.displayName} color={runtime.icon.color} fontSize="1.5rem" type={runtime.icon.type}></IconMode></div>}
            <div className="flex flex-column justify-content-center">
              <div className={`font-bold ${data?.description ? "mb-2" : ""}`}>{data.name}</div>
              {data?.description && <div>{data.description}</div>}
            </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div>
        {!status.isError && (
          <div>
            {/* Component that Filter Treatments  */}
            <HandleTreatment />

            <div>
              {/* List of topologies displayed with component Rows */}

              <DataTable
                value={data?.topologies}
                lazy
                dataKey="id"
                paginator
                first={first}
                rows={paramPagination.perPage}
                totalRecords={data?.totalItems}
                onPage={paginate}
                onSort={onSort}
                loading={status.isLoading}
                sortField={
                  paramPagination.sort !== undefined
                    ? paramPagination.field
                    : undefined
                }
                sortOrder={paramPagination.sort}
                emptyMessage={EmptyMessage}
                rowsPerPageOptions={[5, 10, 15, 20]}
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords}"
                paginatorClassName={"justify-content-end"}
              >
                <Column
                  header="Nom"
                  field="name"
                  sortable
                  body={NameTemplate}
                />
                <Column
                  field="environnement"
                  sortable
                  header="Environnement"
                  body={EnvTemplate}
                />
                <Column
                  field="creationDate"
                  sortable
                  header="Création"
                  body={CretationDateBodyTemplate}
                />
                <Column
                  field="modificationDate"
                  sortable
                  header="Modification"
                  body={ModificationDateBodyTemplate}
                />
                <Column header="Actions" body={ActionsTopology} />
              </DataTable>
            </div>
          </div>
        )}

        {/* case failed to get topologies*/}

        {status.isError && (
          <div>
            <Message
              className="w-full"
              severity="error"
              text="Erreur de chargement des traitements"
            />
          </div>
        )}
      </div>
    </>
  );
};

export default RenderTopologies;
